import WorkshopCard from "components/WorkshopCard";
import FadingSection from "components/fadingSection";
import Section from "components/section";
import Slick from "components/slick";
import { COURSE_SLIDE_CONFIG } from "pages/back-office/constants/course";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import workshopService from "services/workshop.services";
import { homeConstants } from "./constants/HomeConstants";
import PaginationSlideCard from "./components/PaginationSlideCard";
import SkeletonCardLoader from "./components/SkeletonCardLoader";

export default function WorkshopSection() {
  const limitPage = homeConstants.limitPage;
  const [page, setPage] = useState(1);

  const {
    data: dataWorkshop,
    isFetching: isLoadingWorkshop,
    refetch: refetchWorkshop,
  } = workshopService.useQueryGetAllWorkshop({
    queryObj: {
      paging: {
        limit: limitPage,
        start: page * limitPage - limitPage,
      },
    },
  });

  useEffect(() => {
    refetchWorkshop()
  }, [page])

  return (
    <FadingSection>
      <Section className="padding-top-0">
        <div className="section-header justify-content-between">
          <div className="title align-self-center">
            <h1>เวิร์กชอป</h1>
            <span>Workshops</span>
          </div>
          {dataWorkshop?.data?.length ? (
            <div className="view-all align-self-center">
              <Link to="/workshops">
                <button className="btn btn-primary">ดูทั้งหมด</button>
              </Link>
            </div>
          ) : null}
        </div>

        <div className="sa-course-content">
          {isLoadingWorkshop ? (
            <SkeletonCardLoader />
          ) : dataWorkshop?.data ? (
            <Slick
              className="sa-course-slider"
              config={COURSE_SLIDE_CONFIG(dataWorkshop.data.length || 0)}
            >
              {dataWorkshop.data.map((data, index) => {
                return (
                  <WorkshopCard key={`workshop-card-${index}`} data={data} />
                );
              })}
            </Slick>
          ) : (
            <p className="tw-text-center tw-text-gray-300 !tw-py-10 tw-font-extrabold tw-text-2xl">ยังไม่มีเวิร์กชอปที่เปิดสอนในขณะนี้</p>
          )}
        </div>
        <PaginationSlideCard
          page={page}
          total={dataWorkshop?.total}
          limitPage={limitPage}
          setPage={setPage}
        />
      </Section>
    </FadingSection>
  );
}
